import { Button } from "@/components/design-system/Button/Button";
import { URLS } from "@/data/constants";
import { trackCalendlyClick } from "@/utils/analytics";
import React from "react";

import { IconCheckCircle } from "@/components/design-system/basic-icons/IconCheckCircle";

const benefits = [
  "Experience how Bravo's intelligence layer powers modern financial guidance",
  "See how financial conversations surface hidden opportunities",
  "Explore how Bravo can activate engagement across your user base",
  "Understand how Bravo effortlessly fits in with your existing digital footprint",
] as const;

export const GetStartedSection: React.FC = () => {
  const handleCalendlyClick = () => {
    trackCalendlyClick("get_started");
    window.open(URLS.CALENDLY, "_blank");
  };

  return (
    <section className="w-full bg-white">
      <div className="section-inset flex flex-col pt-12 pb-12 md:flex-row md:items-start md:gap-12 md:py-24">
        {/* Left */}
        <div className="mb-8 md:mb-0 md:flex md:min-w-0 md:flex-1 md:justify-end">
          <div className="relative flex w-full flex-col gap-4 md:max-w-114 md:gap-6 md:text-right">
            <p className="caption-bold text-black uppercase">Get Started</p>

            <h2 className="headline-d-extrabold md:headline-c-extrabold text-black">
              See Bravo <span className="text-primary-500">in action.</span>
            </h2>

            <p className="body-a-regular md:subtitle-b-regular text-black">
              Book a 45-minute demo to see the impact Bravo can have on your
              organization today.
            </p>

            <Button
              variant="solid"
              size="lg"
              onClick={handleCalendlyClick}
              className="h-10 w-full rounded-lg px-6 md:h-12 md:w-auto md:self-end md:rounded-[10px]"
            >
              Book a demo
            </Button>
          </div>
        </div>

        {/* Right */}
        <div className="md:min-w-0 md:flex-1">
          <div className="flex w-full flex-col gap-6 rounded-2xl drop-shadow-[0px_0px_32px_#dfc5e0] md:max-w-114">
            {benefits.map((text) => (
              <div key={text} className="flex items-center gap-2">
                <IconCheckCircle className="h-6 w-6 shrink-0" />
                <span className="body-b-regular text-black">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
